import { render, staticRenderFns } from "./frontPoliticaDatosContainer.vue?vue&type=template&id=0af431f0&scoped=true&"
import script from "./frontPoliticaDatosContainer.vue?vue&type=script&lang=js&"
export * from "./frontPoliticaDatosContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af431f0",
  null
  
)

export default component.exports